import { Flex } from "@base-ui";
import { NavSelect, NavButton, ExternalNavButton } from "./header.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function HeaderNav(_ref) {
  var adminAccess = _ref.adminAccess,
    measuresCategories = _ref.measuresCategories,
    reportCategories = _ref.reportCategories;
  return /*#__PURE__*/_jsxs(Flex.Row, {
    as: "ul",
    width: "fit-content",
    children: [/*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx(NavSelect, {
        id: "measures-select",
        inverted: true,
        label: "Indikatorer",
        hideLabel: true,
        _selected: -1,
        width: "150px",
        selectedPrefix: "Indikatorer",
        options: measuresCategories
      })
    }), /*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx(NavSelect, {
        id: "reports-select",
        inverted: true,
        label: "Rapporter",
        hideLabel: true,
        _selected: -1,
        width: "150px",
        selectedPrefix: "Rapporter",
        options: reportCategories
      })
    }), adminAccess && /*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx(ExternalNavButton, {
        href: "http://insikt.vardenisiffror.se/",
        children: "Analysst\xF6d"
      })
    }), /*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx(NavButton, {
        to: "/mina-enhetslistor",
        children: "Mina enhetslistor"
      })
    }), /*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx(NavButton, {
        to: "/dataexport",
        children: "Dataexport"
      })
    }), adminAccess && /*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx(NavButton, {
        to: "/admin",
        children: "Admin"
      })
    })]
  });
}